/**
 * Helper function to be passed into `Array.prototype.filter`. Filters out any
 * questions with a Stage of 0, since Stage 0 is a baseline stage
 * that should have no questions/responses attached to it.
 */
export function excludeBaseStageQuestion(questionStage: number) {
  return questionStage != 0;
}
